import React from 'react';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import {
  ProjectStackField,
  ProjectStackDocument,
} from '~/src/entities/project';
import { ContactSource } from '~/src/entities/contact';
import { PopulateCardField } from './PopulateCardField';
import { isEqual } from 'lodash';
import { useFieldMappingContext } from '~/src/pages/Populate/FieldMappingProvider';

export type PopulateCardFieldsProps = {
  fields: ProjectStackField[];
  projectStackDocuments: ProjectStackDocument[];
  onBlur: (fieldId: string) => void;
  onFocus: (fieldId: string) => void;
  countTouched: (fieldId: string) => void;
  isRoleCard: boolean;
  contactId?: number;
  contactSource?: ContactSource;
};

export const PopulateCardFields = React.memo(
  ({
    fields,
    projectStackDocuments,
    onBlur,
    onFocus,
    countTouched,
    isRoleCard,
    contactId,
    contactSource,
  }: PopulateCardFieldsProps) => {
    const { openWidgetFieldId, setOpenWidgetFieldId } =
      useFieldMappingContext();

    return (
      <>
        {fields.map((projectField) => (
          <Box mb={2} key={projectField.fid}>
            <Controller
              name={projectField.fid}
              render={({ field }) => {
                return (
                  <PopulateCardField
                    field={{
                      ...field,
                      onBlur: () => {
                        field.onBlur();
                        onBlur(projectField.fid);
                      },
                      onFocus: () => onFocus(projectField.fid),
                      countTouched: () => {
                        countTouched(projectField.fid);
                      },
                    }}
                    projectField={projectField}
                    projectStackDocuments={projectStackDocuments}
                    isFieldMappingOpen={openWidgetFieldId === projectField.fid}
                    onFieldMappingOpen={() =>
                      setOpenWidgetFieldId(projectField.fid)
                    }
                    onFieldMappingClose={() => setOpenWidgetFieldId(null)}
                    isRoleCard={isRoleCard}
                    contactId={contactId}
                    contactSource={contactSource}
                  />
                );
              }}
            />
          </Box>
        ))}
      </>
    );
  },
  (prevProps, nextProps) =>
    isEqual(prevProps.fields, nextProps.fields) &&
    isEqual(prevProps.projectStackDocuments, nextProps.projectStackDocuments) &&
    prevProps.contactId === nextProps.contactId &&
    prevProps.contactSource === nextProps.contactSource,
);
